import type { ReactNode } from "react";
import styles from "./Row.module.css";

type SpaceToken = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 12 | 14 | 16;

interface RowProps {
  readonly gap?: SpaceToken;
  readonly align?: "start" | "center" | "end" | "baseline" | "stretch";
  readonly justify?: "start" | "center" | "end" | "between" | "around";
  readonly wrap?: boolean;
  readonly children: ReactNode;
  readonly className?: string;
}

const JUSTIFY_MAP = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  between: "space-between",
  around: "space-around",
} as const;

const ALIGN_MAP = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  baseline: "baseline",
  stretch: "stretch",
} as const;

export function Row({
  gap = 4,
  align = "center",
  justify = "start",
  wrap = true,
  children,
  className,
}: RowProps) {
  return (
    <div
      className={`${styles.row} ${className ?? ""}`}
      style={{
        gap: `var(--space-${gap})`,
        alignItems: ALIGN_MAP[align],
        justifyContent: JUSTIFY_MAP[justify],
        flexWrap: wrap ? "wrap" : "nowrap",
      }}
    >
      {children}
    </div>
  );
}
